import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "~/css/FontSize.css";
import "~/css/reception/ReceptionButton.css";
import "~/css/ReceptionErrorModal.css";

interface ReceptionErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

/**
 * 受付システムがアクティベーションされていない場合に
 * エラーメッセージを表示するモーダル
 */
const ReceptionErrorModal: React.FC<ReceptionErrorModalProps> = ({ isOpen, onClose, message }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const modalMessage = message ?? "";

  const modalContent = (
    <div
      className="reception-error-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={t("error")}
      aria-describedby="reception-error-modal-description"
    >
      <div className="reception-error-modal">
        <div className="reception-error-modal-body">
          <p
            id="reception-error-modal-description"
            className="reception-error-modal-message font-default-normal-24"
          >
            {modalMessage}
          </p>
        </div>

        <button
          type="button"
          className="text-btn gradient-primary-btn reception-error-modal-button"
          onClick={onClose}
        >
          <span>{t("ok")}</span>
        </button>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ReceptionErrorModal;
